/**
 * The helper card text for a find sheet of a multi-part item, worded for which part the
 * player is on. `collected` is the number of parts the player's live hunt for the item has
 * already collected, or `null` when there is no live hunt.
 */
export function multiPartTipText(parts: number, collected: number | null): string {
  const switchHint = 'switch between meters and feet.';
  if (collected === null) {
    return `This item comes in ${parts} parts. Pick this one up to start a hunt: the rest are hidden nearby, and the Hunt tab shows which way to walk and how far to each. Tap a distance there to ${switchHint}`;
  }
  if (collected + 1 < parts) {
    return `This item comes in ${parts} parts and you already have ${collected}. After this one, the Hunt tab keeps showing which way to walk and how far to the remaining parts. Tap a distance there to ${switchHint}`;
  }
  return `This item comes in ${parts} parts and this is the last one you need. Pick it up to assemble it. On future hunts, tap a distance on the Hunt tab to ${switchHint}`;
}
